import React from 'react';
import styles from './PhonePreview.module.css';

class PhonePreview extends React.Component {
  render() {
    const { title = 'Your campaign title', body = 'Your message body appears here…' } = this.props;

    return (
      <div className={styles.wrap}>
        <div className={styles.label}>Live Preview</div>
        <div className={styles.phone}>
          <div className={styles.notch} />
          <div className={styles.time}>9:41</div>
          <div className={styles.notif}>
            <div className={styles.ico}>P</div>
            <div className={styles.content}>
              <div className={styles.title}>{title || 'Your campaign title'}</div>
              <div className={styles.body}>{body || 'Your message body appears here…'}</div>
              <div className={styles.meta}>now · PMW Click</div>
            </div>
          </div>
        </div>
        <div className={styles.caption}>Android lock screen · preview only</div>
      </div>
    );
  }
}

export default PhonePreview;
